export default {
  orsLPolyline: {
    'type': 'Tipo',
    'surface': 'Superficie',
    'unknownSurfaceType': 'Sconosciuto'
  }
}
